import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import { SafetyDesktopRouter } from "./common/routers/SafetyDesktopRouter"
import { SafetyMobileRouter } from "./common/routers/SafetyMobileRouter/SafetyMobileRouter"
import { IncidentsContextProvider } from "./modules/incidents/contexts/IncidentsContext"
import { RiskZonesContextProvider } from "./modules/riskZones/contexts/RiskZonesContext"
import { SpeedingsContextProvider } from "./modules/speedings/contexts/SpeedingsContext"

export function L2rAppSafety() {
    const isMobile = useIsMobileDevice()

    return (
        <IncidentsContextProvider>
            <RiskZonesContextProvider>
                <SpeedingsContextProvider>
                    {
                        isMobile ? <SafetyMobileRouter /> : <SafetyDesktopRouter />
                    }
                </SpeedingsContextProvider>
            </RiskZonesContextProvider>
        </IncidentsContextProvider>
    )
}
